import React from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import ContentLoader from 'react-content-loader';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    itemContainer: {
      overflow: 'hidden',
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.grey[300],
    },
    innerContainer: {
      zIndex: 100,
    },
  });

interface Props extends WithStyles<typeof styles> {
  numberOfRows: number;
  height: number | string;
  width: number | string;
}

const LoadingSkeleton: React.FunctionComponent<Props> = (props) => {
  const { classes, numberOfRows, height, width } = props;
  const numberOfSkeletonRows = Array(numberOfRows).fill(null);

  return (
    <div className={classes.container}>
      {numberOfSkeletonRows.map(() => (
        <div className={classes.itemContainer} style={{ height, width }}>
          <div className={classes.innerContainer}>
            <ContentLoader>
              <rect x="30" y="40" rx="3" ry="3" width="140" height="32" />
              <rect x="30" y="80" rx="3" ry="3" width="240" height="26" />
            </ContentLoader>
          </div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(LoadingSkeleton);
